import { IsOptional, IsString, Matches, MaxLength } from "class-validator";

/**
 * "Share to feed" customization of a club's event_published post. Both
 * fields are optional; an empty string clears. The flyer must be an image
 * URL so the feed never renders a broken <img>.
 */
export class UpdateEventFeedPostDto {
  @IsOptional()
  @IsString()
  @MaxLength(2000)
  body?: string;

  @IsOptional()
  @IsString()
  @Matches(/^$|\.(jpe?g|png|webp)(\?.*)?$/i, { message: "flyer_image_url must be a JPG, PNG or WebP image URL" })
  flyer_image_url?: string;
}
